
export const phasesconstants = {
    SHOW_PHASES : "SHOW_PHASES",
    CREATE_PHASE : "CREATE_PHASE",
    UPDATE_PHASE : "UPDATE_PHASE",
    DELETE_PHASE : "DELETE_PHASE",
    ADD_TO_PHASE : "ADD_TO_PHASE",
    REMOVE_FROM_PHASE : "REMOVE_FROM_PHASE",
    GET_ALL_PHASE : "GET_ALL_PHASE",
};